import React from 'react';

// Shared SVG icon library — outline 1.5 stroke, 24x24 viewBox.
// All icons accept { size, color, strokeWidth, fill, className }.

const base = (size, color, strokeWidth, className) => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: color,
  strokeWidth: strokeWidth,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  className,
  'aria-hidden': true,
});

export const Sun = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, fill = 'transparent', className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <circle cx="12" cy="12" r="3.6" fill={fill} />
    <path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.6 4.6l2.1 2.1M17.3 17.3l2.1 2.1M4.6 19.4l2.1-2.1M17.3 6.7l2.1-2.1" />
  </svg>
);

export const Moon = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, fill = 'transparent', className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <path d="M19 14.79A8 8 0 0 1 9.21 5a8 8 0 0 0 9.79 9.79z" fill={fill} />
  </svg>
);

export const Coffee = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <path d="M5 8h11v6a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4V8z" />
    <path d="M16 9h2.5a2.5 2.5 0 0 1 0 5H16" />
    <path d="M7 3v2M11 3v2M15 3v2" />
  </svg>
);

export const Briefcase = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <rect x="3" y="7" width="18" height="13" rx="2" />
    <path d="M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
    <path d="M3 13h18" />
  </svg>
);

export const Users = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <circle cx="9" cy="8" r="3.2" />
    <path d="M2.5 19c0-3 2.9-5 6.5-5s6.5 2 6.5 5" />
    <circle cx="17" cy="9" r="2.6" />
    <path d="M22 18.2c0-2-1.7-3.7-4-4" />
  </svg>
);

export const BookOpen = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <path d="M2.5 5h6.5a3 3 0 0 1 3 3v12a2.5 2.5 0 0 0-2.5-2.5H2.5V5z" />
    <path d="M21.5 5H15a3 3 0 0 0-3 3v12a2.5 2.5 0 0 1 2.5-2.5h6.5V5z" />
  </svg>
);

export const Compass = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <circle cx="12" cy="12" r="9" />
    <path d="M15.5 8.5l-1.6 4.6-4.6 1.6 1.6-4.6 4.6-1.6z" />
  </svg>
);

export const Leaf = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <path d="M11 20A7 7 0 0 1 4 13c0-7 7-9 14-9 0 7-2 14-9 14-1.5 0-3-.5-4-1.5" />
    <path d="M5 18c4-3 6-7 9-12" />
  </svg>
);

export const Sparkle = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, fill = 'transparent', className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <path d="M12 3l1.6 5.4 5.4 1.6-5.4 1.6L12 17l-1.6-5.4L5 10l5.4-1.6L12 3z" fill={fill} />
  </svg>
);

export const Bolt = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, fill = 'transparent', className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <path d="M13 2 4 14h7l-1 8 9-12h-7l1-8z" fill={fill} />
  </svg>
);

export const Heart = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, fill = 'transparent', className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <path d="M20.8 8.6c0 5-8.8 11.4-8.8 11.4S3.2 13.6 3.2 8.6a4.6 4.6 0 0 1 8.8-1.6 4.6 4.6 0 0 1 8.8 1.6z" fill={fill} />
  </svg>
);

export const Cloud = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <path d="M7 18a4.5 4.5 0 0 1-.6-9 6 6 0 0 1 11.6 1.6A3.5 3.5 0 0 1 17 18H7z" />
  </svg>
);

export const Wind = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <path d="M3 8h11a3 3 0 1 0-3-3" />
    <path d="M3 12h17a3 3 0 1 1-3 3" />
    <path d="M3 16h7" />
  </svg>
);

export const Smile = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <circle cx="12" cy="12" r="9" />
    <path d="M9 9.5h.01M15 9.5h.01M8.5 14a4.5 4.5 0 0 0 7 0" />
  </svg>
);

export const ArrowRight = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <path d="M5 12h14M13 5l7 7-7 7" />
  </svg>
);

export const ArrowUp = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <path d="M12 19V5M5 12l7-7 7 7" />
  </svg>
);

export const ChevronRight = ({ size = 16, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <path d="M9 6l6 6-6 6" />
  </svg>
);

export const ChevronDown = ({ size = 16, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <path d="M6 9l6 6 6-6" />
  </svg>
);

export const Plus = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <path d="M12 5v14M5 12h14" />
  </svg>
);

export const Settings = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3 1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8v0a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" />
  </svg>
);

export const Bell = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9z" />
    <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
  </svg>
);

export const Lock = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <rect x="4" y="11" width="16" height="11" rx="2" />
    <path d="M8 11V7a4 4 0 0 1 8 0v4" />
  </svg>
);

export const Shield = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <path d="M12 3l8 3v6c0 5-4 8.5-8 9-4-.5-8-4-8-9V6l8-3z" />
  </svg>
);

export const Database = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <ellipse cx="12" cy="5" rx="8" ry="3" />
    <path d="M4 5v6c0 1.7 3.6 3 8 3s8-1.3 8-3V5" />
    <path d="M4 11v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6" />
  </svg>
);

export const HelpCircle = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <circle cx="12" cy="12" r="9" />
    <path d="M9.5 9.5a2.5 2.5 0 1 1 5 0c0 1.5-2.5 2-2.5 4M12 17h.01" />
  </svg>
);

export const Link = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <path d="M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1" />
    <path d="M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1" />
  </svg>
);

export const Edit = ({ size = 16, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.4 2.6a2 2 0 1 1 2.8 2.8L12 14.6 8 16l1.4-4 9-9z" />
  </svg>
);

export const Check = ({ size = 16, color = 'currentColor', strokeWidth = 2, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <path d="M5 12.5l4.5 4.5L19 7" />
  </svg>
);

export const X = ({ size = 16, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
);

export const PenLine = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.1 2.1 0 1 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
  </svg>
);

export const Target = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <circle cx="12" cy="12" r="9" />
    <circle cx="12" cy="12" r="5" />
    <circle cx="12" cy="12" r="1.5" fill={color} stroke="none" />
  </svg>
);

export const Repeat = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <path d="M17 2.5l4 4-4 4M3 11V9a4 4 0 0 1 4-4h14M7 21.5l-4-4 4-4M21 13v2a4 4 0 0 1-4 4H3" />
  </svg>
);

export const TrendingUp = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <path d="M3 17l6-6 4 4 8-8" />
    <path d="M14 7h7v7" />
  </svg>
);

export const Music = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <path d="M9 18V5l12-2v13" />
    <circle cx="6" cy="18" r="3" />
    <circle cx="18" cy="16" r="3" />
  </svg>
);

export const VolumeOff = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <path d="M11 5L6 9H3v6h3l5 4V5z" />
    <path d="M22 9l-6 6M16 9l6 6" />
  </svg>
);

export const Lightbulb = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <path d="M9 21h6M10 17h4M8 13a5 5 0 1 1 8 0c-1.5 1.5-2 2.5-2 4h-4c0-1.5-.5-2.5-2-4z" />
  </svg>
);

export const Flame = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, fill = 'transparent', className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <path d="M12 2c0 5-5 5-5 11a5 5 0 0 0 10 0c0-3-2-5-2-7 0 1-1.5 2-3 2 0-3 0-3 0-6z" fill={fill} />
  </svg>
);

export const Zap = Bolt;

export const Sparkles = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <path d="M12 3v3M12 18v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M3 12h3M18 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

export const Pause = ({ size = 18, color = 'currentColor', strokeWidth = 1.5, className = '' }) => (
  <svg {...base(size, color, strokeWidth, className)}>
    <rect x="6" y="5" width="4" height="14" rx="1" />
    <rect x="14" y="5" width="4" height="14" rx="1" />
  </svg>
);
